import type { ReactNode } from 'react';

interface FormFieldProps {
  label: string;
  htmlFor?: string;
  error?: string;
  hint?: string;
  children: ReactNode;
}

export function FormField({ label, htmlFor, error, hint, children }: FormFieldProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <label
        htmlFor={htmlFor}
        style={{ fontSize: 13, fontWeight: 500, color: '#475569' }}
      >
        {label}
      </label>
      {children}
      {hint && !error && (
        <span style={{ fontSize: 12, color: '#64748b' }}>{hint}</span>
      )}
      {error && (
        <span style={{ fontSize: 12, color: '#dc2626' }}>{error}</span>
      )}
    </div>
  );
}